import eventApi from '@/api/event.api'

export const eventService = (function () {
  'use strict'


  /**
   * Devuelve todos los eventos para el selector de eventos en el ABM de empresas
   */
  async function findAllForSelector() {
    try {
      const response = await eventApi.findAllForSelector()
      return response.data
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  /**
   * Devuelve todos los eventos para el selector de eventos en el ABM de empresas, aplicables a una empresa
   */
  async function findAllForSelectorByEnterprise(enterpriseId) {
    try {
      const response = await eventApi.findAllForSelector(enterpriseId)
      return response.data
    } catch (exception) {
      console.log(exception)
      return []
    }
  }

  /**
   * Datos para la tabla del ABM de tipos de eventos
   * @param {*} pageSize
   * @param {*} pageNumber
   */
  // eslint-disable-next-line no-unused-vars
  async function findAllEventType(pageSize, pageNumber) {
    try {
      /*
      if (pageSize > 0 && pageNumber > 0) {
        const response = await eventApi.findAll(pageSize, pageNumber)
        return response.data
      } else {
        return {
          data: [],
          headers: []
        }
      }
      */
      const response = await eventApi.findAllEventType(undefined, undefined)
      return response.data
    } catch (exception) {
      console.log(exception)
      return {
        data: [],
        headers: []
      }
    }
  }

  /**
   * Total de tipos de eventos de la colección
   */
  async function getEventTypeTotal() {
    try {
      const response = await eventApi.getEventTypeTotal()
      return response.data
    } catch (exception) {
      console.log(exception)
      return 0
    }
  }

  /**
   * Devuelve los datos de un tipo de evento a partir de su id, para la actualización
   * @param {*} eventTypeId
   */
  async function findOneEventType (eventTypeId) {
    try {
      const response = await eventApi.findOneEventType(eventTypeId)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
  }

  /**
   * Para eliminar un tipo de evento
   * Primero se valida de que no exista una relación con una cosa en la collection de eventos
   * @param {*} id
   */
  async function deleteOneEventType(id) {
    try {
        const response = await eventApi.deleteOneEventType(id)
        return response.data
    } catch (exception) {
        console.log(exception)
        return null
    }
  }

  /**
   * Para eliminación múltiple
   * Por cada evento, se hace la misma validación que cuando se elimina un único evento
   */
  async function deleteManyEventType(ids) {
    try {
        const response = await eventApi.deleteManyEventType(ids)
        return response.data
    } catch (exception) {
        console.log(exception)
        return null
    }
  }


  /**
   * Crea un nuevo tipo de evento en la collection
   * @param {*} eventType
   */
  async function createEventType(eventType) {
    const response = await eventApi.createEventType(eventType)
    return response.data
  }

  /**
   * Actualiza un tipo de evento existente en la collection
   * @param {*} eventType
   */
  async function updateEventType(eventType) {
    const response = await eventApi.updateEventType(eventType)
    return response.data
  }

  /**
   * Validación de una traducción del nombre
   * @param {*} locale 
   * @param {*} translation 
   * @param {*} id 
   */
  async function validateTranslation(locale, translation, id) {
    try {
      if (translation) {
        const response = await eventApi.validateTranslation(locale, translation, id)
        return response.data
      } else {
        return false
      }
    } catch (exception) {
      console.log(exception)
      return false
    }
  }

  return {
    findAllForSelector,
    getEventTypeTotal,
    findAllEventType,
    findOneEventType,
    deleteOneEventType,
    deleteManyEventType,
    createEventType,
    updateEventType,
    validateTranslation,
    findAllForSelectorByEnterprise
  }
})()